import { lazy } from "react";
import {
  KEY_SANTE_ANIMALE,
  TITLE_SANTE_ANIMALE,
  PATH_SANTE_ANIMALE,
  PATH_SANTE_ANIMALE_MALADIE_REFERENCE,
  KEY_SANTE_ANIMALE_MALADIE_REFERENCE,
  TITLE_SANTE_ANIMALE_MALADIE_REFERENCE,
  PATH_SANTE_ANIMALE_MEDICAMENT_REFERENCE,
  KEY_SANTE_ANIMALE_MEDICAMENT_REFERENCE,
  TITLE_SANTE_ANIMALE_MEDICAMENT_REFERENCE,
  PATH_SANTE_ANIMALE_VACCIN_REFERENCE,
  KEY_SANTE_ANIMALE_VACCIN_REFERENCE,
  TITLE_SANTE_ANIMALE_VACCIN_REFERENCE,
  PATH_SANTE_ANIMALE_VACCIN,
  KEY_SANTE_ANIMALE_VACCIN,
  TITLE_SANTE_ANIMALE_VACCIN,
  PATH_SANTE_ANIMALE_VACCINATION,
  KEY_SANTE_ANIMALE_VACCINATION,
  TITLE_SANTE_ANIMALE_VACCINATION,
} from "layouts/santeAnimale/constant/path";

import { buildRouteItem } from "router/routesUtils";

const MaladieReference = lazy(() => import("layouts/santeAnimale/rubrique/maladieReference"));
const MedicamentReference = lazy(() => import("layouts/santeAnimale/rubrique/medicamentReference"));
const VaccinReference = lazy(() => import("layouts/santeAnimale/rubrique/vaccinReference"));
const Vaccin = lazy(() => import("layouts/santeAnimale/rubrique/vaccin"));
const Vaccination = lazy(() => import("layouts/santeAnimale/rubrique/vaccination"));

const SANTE_ANIMALE_MENU_ITEMS = [
  {
    title: TITLE_SANTE_ANIMALE_MALADIE_REFERENCE,
    key: KEY_SANTE_ANIMALE,
    path: PATH_SANTE_ANIMALE,
    component: MaladieReference,
  },
  {
    title: TITLE_SANTE_ANIMALE_MALADIE_REFERENCE,
    key: KEY_SANTE_ANIMALE_MALADIE_REFERENCE,
    path: PATH_SANTE_ANIMALE_MALADIE_REFERENCE,
    component: MaladieReference,
  },
  {
    title: TITLE_SANTE_ANIMALE_MEDICAMENT_REFERENCE,
    key: KEY_SANTE_ANIMALE_MEDICAMENT_REFERENCE,
    path: PATH_SANTE_ANIMALE_MEDICAMENT_REFERENCE,
    component: MedicamentReference,
  },
  {
    title: TITLE_SANTE_ANIMALE_VACCIN_REFERENCE,
    key: KEY_SANTE_ANIMALE_VACCIN_REFERENCE,
    path: PATH_SANTE_ANIMALE_VACCIN_REFERENCE,
    component: VaccinReference,
  },
  {
    title: TITLE_SANTE_ANIMALE_VACCIN,
    key: KEY_SANTE_ANIMALE_VACCIN,
    path: PATH_SANTE_ANIMALE_VACCIN,
    component: Vaccin,
  },
  {
    title: TITLE_SANTE_ANIMALE_VACCINATION,
    key: KEY_SANTE_ANIMALE_VACCINATION,
    path: PATH_SANTE_ANIMALE_VACCINATION,
    component: Vaccination,
  },
];

const ROUTES_SANTE_ANIMALE = [
  buildRouteItem(
    TITLE_SANTE_ANIMALE,
    KEY_SANTE_ANIMALE,
    PATH_SANTE_ANIMALE,
    SANTE_ANIMALE_MENU_ITEMS,
    "vaccines"
  ),
];
export default ROUTES_SANTE_ANIMALE;
